/**
 * 顶层组件（架构 §2 src/App.tsx / T03 / T10）
 *  - 注册 axios 鉴权失效跳转钩子（1001/1002 -> /login）
 *  - 渲染路由表与全局反馈组件
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import Feedback from './components/common/Feedback';
import { setAuthFailHandler } from './api/client';

export default function App() {
  const navigate = useNavigate();

  useEffect(() => {
    setAuthFailHandler(() => navigate('/login', { replace: true }));
  }, [navigate]);

  return (
    <>
      <AppRoutes />
      <Feedback />
    </>
  );
}
